import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { modalActions, accountActions } from '../../redux/root-action';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import ReactModalHeader from '../Modal/ReactModalHeader';
import ReactModalContent from '../Modal/ReactModalContent';
import { modals, accountModalViews } from '../../utils/constants';
import { analyticsTracking } from 'utils/constants';

const StyledCard = styled.a`
  text-decoration: none;
  display: flex;
  border-radius: 4px;
  border: solid 1px ${tokens.ColorWhite200};
  background-color: ${tokens.ColorWhite000};
  padding: 24px;
  cursor: pointer;
  margin: 8px 0px 8px 0px;
  &:hover,
  &:focus {
    border: solid 1px ${tokens.ColorBrandInteractiveBlue};
    box-shadow: 0 4px 4px 0 rgba(45, 57, 64, 0.08), 0 0 2px 0 rgba(45, 57, 64, 0.12);
    text-decoration: none;
  }
  @media only screen and (max-width: 767px) {
    align-items: flex-start;
  }
`;

const StyledTextContainer = styled.div`
  margin-left: 24px;
`;

const StyledText = styled.div`
  font-family: Nimbus Sans Bold;
  font-size: 20px;
  color: ${tokens.ColorBrandInteractiveBlue};
  @media only screen and (max-width: 767px) {
    font-size: 16px;
  }
`;

const StyledContainer = styled.div`
  padding: 16px 0px 40px 0px;
`;

const card: Record<string, any> = {
  add: {
    title: 'Securely Add Account or Spouse Information',
    accountCard: {
      header: 'Add Accounts',
      body: 'Securely add your other accounts for the total picture.',
    },
    spouseCard: {
      header: 'Add Spouse Information',
      body: 'Get a household view with up-to-date spouse information.',
    },
  },
  update: {
    title: 'Securely Add/Edit Accounts or Spouse Information',
    accountCard: {
      header: 'Add/Edit Accounts',
      body: 'Keep your accounts up to date for an accurate outlook.',
    },
    spouseCard: {
      header: 'Add/Edit Spouse Information',
      body: 'Get a household view with up-to-date spouse information.',
    },
  },
};

class AddAccountOrSpouse extends Component<any, any> {
  showSpouseProfileModal = () => {
    const { showModal } = this.props;
    showModal(modals.SPOUSE_PROFILE);
  };

  showSpouseProfileModalOnKeyPress = (e: any) => {
    if (e.nativeEvent.code === 'Enter') {
      this.showSpouseProfileModal();
    }
  };

  showAddOrEditSpouseProfileModal = () => {
    const { showModal } = this.props;
    showModal(modals.ADD_SPOUSE_PROFILE);
  };

  showAddOrEditSpouseProfileModalOnKeyPress = (e: any) => {
    if (e.nativeEvent.code === 'Enter') {
      this.showAddOrEditSpouseProfileModal();
    }
  };

  showYourAccountsModal = () => {
    const { showModal, setCurrentView } = this.props;
    showModal(modals.ACCOUNT);
    setCurrentView(accountModalViews.YOUR_ACCOUNTS);
  };

  showYourAccountsModalOnKeyPress = (e: any) => {
    if (e.nativeEvent.code === 'Enter') {
      this.showYourAccountsModal();
    }
  };

  render(): JSX.Element {
    const accountCardType = 'update';
    const { isSpouseDataAvailable } = this.props;
    const spouseCardType = isSpouseDataAvailable ? 'update' : 'add';
    return (
      <React.Fragment>
        <ReactModalHeader modalTitle={card[accountCardType].title} showClose={true} />
        <ReactModalContent>
          <StyledContainer id={`add-account-container`}>
            <StyledCard
              onClick={this.showYourAccountsModal}
              tabIndex={0}
              onKeyPress={this.showYourAccountsModalOnKeyPress}
              id={analyticsTracking.RIXAddEditAccount}
            >
              <img src={`data:image/svg+xml;base64,${tokens.AssetIconPieChart2}`} alt="pie chart icon" />
              <StyledTextContainer id={`add-account-text-container`} tabIndex={0}>
                <StyledText id={`add-account-card-header`}>{card[accountCardType].accountCard.header}</StyledText>
                <div id={`add-account-card-body`}>{card[accountCardType].accountCard.body}</div>
              </StyledTextContainer>
            </StyledCard>
            <StyledCard
              onClick={isSpouseDataAvailable ? this.showSpouseProfileModal : this.showAddOrEditSpouseProfileModal}
              tabIndex={0}
              onKeyPress={
                isSpouseDataAvailable
                  ? this.showSpouseProfileModalOnKeyPress
                  : this.showAddOrEditSpouseProfileModalOnKeyPress
              }
              id={`analyticsTracking.RIXAddEditSpouse`}
            >
              <img
                id={`add-account-spouse-icon`}
                src={`data:image/svg+xml;base64,${tokens.AssetIconPartner}`}
                alt="spouse icon"
              />
              <StyledTextContainer id={`add-txt-container`} tabIndex={0}>
                <StyledText id={`add-account-txt`}>{card[spouseCardType].spouseCard.header}</StyledText>
                <div id={`add-account-spouse-card`}>{card[spouseCardType].spouseCard.body}</div>
              </StyledTextContainer>
            </StyledCard>
          </StyledContainer>
        </ReactModalContent>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ addAccount, riScenario: { spouseProfile } }: any) => ({
  accountFields: addAccount,
  isSpouseDataAvailable: spouseProfile && spouseProfile.bpId,
});

export default connect(mapStateToProps, {
  hideModal: modalActions.hideModal,
  showModal: modalActions.showModal,
  setCurrentView: accountActions.setCurrentView,
})(AddAccountOrSpouse);
